import React from 'react';
import FeatureCard from '../components/FeatureCard';
import {getErrorIssues} from '../../../../../../../utils/validationSummary';
import DraggableAreaChart from '../charts/DraggableAreaChart';

class SensorGraphCluster extends React.Component {

    getDataChart() {
        const {silentDimmingLevel, occupyDimmingLevel, fadingInTime, holdUpTime, fadingOutTime} = this.props;
        let dataChart = [{}, {}, {}, {}, {}, {}];

        dataChart[0] = {
            x: 0,
            y: +silentDimmingLevel.value,
            timeLabel: 'unoccupied-0',
            section: 0,
        };

        dataChart[1] = {
            x: 100,
            y: +silentDimmingLevel.value,
            timeLabel: 'unoccupied-0',
            section: 0,
        };

        const fadingInIndex = fadingInTime.valueMeta.availableValues.indexOf(fadingInTime.value);
        dataChart[2] = {
            x: dataChart[1].x + (fadingInIndex > 0 ? fadingInIndex * 12 : 0),
            y: +occupyDimmingLevel.value,
            timeLabel: 'fadingIn-1',
            section: 1,
        };

        dataChart[3] = {
            x: dataChart[2].x + 180,
            y: +occupyDimmingLevel.value,
            timeLabel: 'occupied-2',
            section: 2,
        };

        const holdUpIndex = holdUpTime.value === 'Off'
            ? 0
            : holdUpTime.valueMeta.availableValues.indexOf(holdUpTime.value);
        dataChart[4] = {
            x: dataChart[3].x + (holdUpIndex > 0 ? holdUpIndex * 11 : 0),
            y: +occupyDimmingLevel.value,
            timeLabel: 'holdUp-3',
            section: 3,
        };

        const fadingOutIndex = fadingOutTime.valueMeta.availableValues.indexOf(fadingOutTime.value);
        dataChart[5] = {
            x: dataChart[4].x + (fadingOutIndex > 0 ? fadingOutIndex * 12 : 0),
            y: +silentDimmingLevel.value,
            timeLabel: 'fadingOut-4',
            section: 4,
        };

        dataChart[6] = {
            x: dataChart[5].x + 100,
            y: +silentDimmingLevel.value,
            timeLabel: 'fadingOut-4',
            section: 4,
        };

        return dataChart;
    }

    getXLabels(dataChart) {
        const labels = [];
        const smallLabels = [];
        const ticks = [];
        dataChart.forEach((el, index) => {
            switch (el.timeLabel) {
                case 'unoccupied-0':
                    ticks.push(el.x);
                    labels.push({label: 'Unoccupied', x: el.x});
                    break;
                case 'fadingIn-1':
                    ticks.push(el.x);
                    smallLabels.push({label: '1', x: (el.x + dataChart[index].x) / 2});
                    break;
                case 'occupied-2':
                    ticks.push(el.x);
                    labels.push({label: 'Detected', x: el.x});
                    break;
                case 'holdUp-3':
                    ticks.push(el.x);
                    smallLabels.push({label: '2', x: (el.x + dataChart[index].x) / 2});
                    break;
                case 'fadingOut-4':
                    ticks.push(el.x);
                    smallLabels.push({label: '3', x: (el.x + dataChart[index].x) / 2});
                    break;
                default:
                    break;
            }
        });
        return {labels, smallLabels, ticks};
    }

    getYLabels() {
        const {silentDimmingLevel, occupyDimmingLevel} = this.props;
        const labels = {};
        const occupy = +occupyDimmingLevel.value;
        const silent = +silentDimmingLevel.value;
        labels[occupy] = {label: occupy, y: occupy};
        if (!labels[silent]) {
            labels[silent] = {label: silent, y: silent};
        }
        if (!labels[0]) {
            labels[0] = {label: '', y: 0};
        }
        return Object.keys(labels).map((key) => labels[key]);
    }

    render() {
        const dataChart = this.getDataChart();
        const maxX = Math.max(...dataChart.map((el) => el.x));

        return (
            /* Titleless on purpose: the legacy markup rendered an empty
               .card-header-feature div purely for the top gap. Converted outright
               rather than behind a `variant` flag because SensorMode is the only
               consumer of this molecule. */
            <FeatureCard variant="modern" className={this.props.className}>
                <DraggableAreaChart
                    containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                    id={'sensorMode'}
                    properties={this.props.properties}
                    dataChart={dataChart}
                    x={{title: 'Time'}}
                    y={{title: 'Output Level (%)'}}
                    min={{y: 0, x: 0}}
                    max={{y: 110, x: maxX}}
                    tickValues={{x: [], y: []}}
                    xLabels={this.getXLabels(dataChart)}
                    yLabels={this.getYLabels()}
                    sections={{
                        0: 'area-dark',
                        1: 'area-light',
                        2: 'area-light',
                        3: 'area-light',
                        4: 'area-dark'
                    }}
                    handleChange={this.props.handleChange}/>
            </FeatureCard>
        );
    }
}

export default SensorGraphCluster;
